import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import { useParams } from "react-router-dom";
import { UserProvider, useUser } from '../../context/UserContext'
import Svg from '../../static/user.svg'


let ListUsers = ( { users } ) => {
  return (
    <div className="icons">
      {users.map( (item, i) => {
        return (<a href={item.profile_url} key={i}><img src={item.profile_image} key={item.id} /></a>);
      })}
    </div>
  )
}

let ApoyarCausa = ( { data } ) => {
  let intento = 0;
  
  const [userApoya, setUserApoya] = useState(false);
  const [componentReady, setComponentReady] = useState(false);  
  const [statsApoyo, setStatsApoyo] = useState(null);
  
  const { usuario, cargandoUsuario, setCargandoUsuario, setData, login, setLogin, logout, FBLogin } = useUser();
  
  const updateApoyos = () => {
    
    Axios.get(process.env.REACT_APP_API + '/api/v1/causas/apoyos?causa_id=' + data)
         .then( response => {
           setStatsApoyo(response.data);
           console.log(usuario.local_id);
           response.data.users.forEach((item, i) => {
             if( item.id == usuario.local_id ) {
               setUserApoya(true);
               console.log(userApoya);
             }
           });
           
         })
         .catch( e => {
           console.log(e);
         })
  }
  
  const cbApoyar = (e) => {
    e.preventDefault()
    Axios.post(process.env.REACT_APP_API + '/api/v1/causas/apoyar', { causa_id : data, user_id : usuario.local_id })
         .then( response => {
           setUserApoya(true);
           updateApoyos();
         })
         .catch( e => {
           console.log(e);
         })  
  } 
  
  const cbDejarApoyar = (e) => {
    e.preventDefault()
    Axios.post(process.env.REACT_APP_API + '/api/v1/causas/dejar_apoyar', { causa_id : data, user_id : usuario.local_id })
         .then( response => {
           setUserApoya(false);
           updateApoyos();
         })
         .catch( e => {
           console.log(e);
         })  
  } 
  
  useEffect( () => {
    updateApoyos();
    
  }, [usuario, userApoya]);
  
  return (
    <section className="apoyar_causa" style={{ opacity : cargandoUsuario == true ? 0 : 1 }}>
      { usuario === null ? <a href="#" className="fb-btn" onClick={e => { e.preventDefault(); FBLogin();}}>Iniciar sesión con facebook</a> : (
        <a href="#" className="button" onClick={ userApoya === false ? cbApoyar : cbDejarApoyar } >{ userApoya === false ? "Apoyar causa" : "Dejar de Apoyar" }</a>) }
      { !userApoya &&
      <div className="check">
        <label htmlFor="">
          <input type="checkbox"/> compartir con mis amigos de Facebook
        </label>
      </div>
      }
      <div className="apoyo">
        { statsApoyo !== null ? (<h3> {statsApoyo.total} personas apoyan</h3>) : null }
        { statsApoyo !== null ? (<ListUsers users={statsApoyo.users} />) : null }
        
      </div>
    </section>
  )
}

export default ApoyarCausa